export default __webpack_public_path__ + "static/media/solteiroduplo_2.6c5c57de.jpg";